import React from 'react'

const Color = () => {
  return (
    <div className="isave-color">
      <h4>color</h4>
      <div className='isave-color_box' />
    </div>
  )
}

export default Color